import { useResizeObserver } from '@fs/zion-frontend-friends'
import { useCallback, useRef } from 'react'

/** To use the width of the screen without the scrollbar. This is needed for a
 * sticky header to be the same width as the content and not blow into the
 * scrollbar due to how zion handles scrollbars.
 */
export default function useAppContentScrollerWidth(onChange: (appWidthNumber: number) => void): void {
  const appContentScroller = useRef(document.querySelector<HTMLDivElement>('#app-content-scroller'))

  useResizeObserver(
    appContentScroller,
    useCallback(
      (entry) => {
        const clientWidth = entry.contentRect.width
        if (clientWidth) {
          onChange(clientWidth)
        }
      },
      [onChange]
    )
  )
}
